const Style = {
  onboarding:
    "flex items-center justify-center min-h-full text-left",
};

export default Style;
